import { asList, imgUrl } from "@/lib/api";

export const projectShots = (projects) =>
  projects.flatMap((p) => asList(p.images).map((img) => ({ project: p, img })));

export const PrintInterlude = ({ shot, n, next }) => {
  const p = shot.project;
  const specs = asList(p.specs).slice(0, 3);
  return (
    <section className="sheet interlude flex flex-col" data-testid={`print-interlude-${n}`}>
      <div className="flex-1 min-h-0 overflow-hidden bg-[#14130f]">
        <img src={imgUrl(shot.img)} alt={p.name} className="w-full h-full object-cover" />
      </div>
      <div className="pt-6 grid grid-cols-[1.3fr_1fr] gap-8 items-end">
        <div>
          <p className="font-mono-j text-[9px] tracking-[0.3em] uppercase text-[#9a7b26]">From our projects</p>
          <h2 className="font-display font-light text-[40px] leading-[1] text-[#14130f] mt-2">{p.name}</h2>
          {p.description && <p className="mt-3 text-[11px] leading-relaxed text-[#3b3933] max-w-[95mm]">{p.description}</p>}
        </div>
        <div>
          {specs.map((s, i) => (
            <div key={i} className="flex justify-between border-t border-[#e6dfcc] py-1 text-[10px] text-[#3b3933]">
              <span className="uppercase tracking-wider text-[#8a857a]">{s.label}</span><span>{s.value}</span>
            </div>
          ))}
          {next && <p className="mt-4 font-mono-j text-[9px] tracking-[0.3em] uppercase text-[#8a857a]">Next — {next}</p>}
        </div>
      </div>
    </section>
  );
};
